import type { BoardModel } from './models/board/BoardModel';
import type { TrayModel } from './models/tray/TrayModel';
import { BoardView } from './views/board/BoardView';
import type { TrayViewSettings } from './views/tray/TrayView';
import { TrayView } from './views/tray/TrayView';
import { DebugBoardView } from './views/board/DebugBoardView';
import { TweenManager } from '../../libs/TweenManager/TweenManager';
import { BoardHintsView } from './views/board/BoardHintsView';
import { BoardViewFactory } from './views/board/BoardViewFactory';

interface GameAreaViewConfig {
  boardModel: BoardModel;
  trayModel: TrayModel;
  trayViewSettings: TrayViewSettings;
}

export class GameAreaView {
  public readonly boardView: BoardView;

  public readonly ownTweens = new TweenManager();

  public readonly viewFactory = new BoardViewFactory();

  public readonly trayView: TrayView;

  public readonly hintsView: BoardHintsView;

  private readonly boardModel: BoardModel;

  constructor({ trayViewSettings, boardModel, trayModel }: GameAreaViewConfig) {
    this.boardModel = boardModel;

    this.boardView = new BoardView(boardModel, this.viewFactory);

    this.trayView = new TrayView(this.viewFactory, trayModel, trayViewSettings);

    this.hintsView = new BoardHintsView(this.boardView.highlightLayer);

    // this.createDebugView().props({
    //   parent: this.boardView.pixi.stage,
    //   y: 200,
    //   scale: 0.5,
    // });
  }

  public update(deltaTime: number): void {
    this.ownTweens.update(deltaTime * (1000 / 60));
  }

  public createDebugView(): DebugBoardView {
    const debugView = new DebugBoardView(this.boardModel);
    const intervalId = setInterval(() => {
      if (debugView.destroyed) {
        clearInterval(intervalId);
      } else {
        debugView.redraw();
      }
    }, 60);

    this.boardView.on('destroyed', () => {
      debugView.destroy({ children: true });
    });
    return debugView;
  }
}
